import { AfterContentInit, Component, Input } from '@angular/core'
import { Fees, PriceRange } from '../../../../../graphql'

@Component({
    selector: 'app-booking-price-range',
    templateUrl: 'booking-price-range.html'
})
export class BookingPriceRangeComponent {
    @Input() priceRange: PriceRange
}
